// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"191":"67de34a6569f1252e891","245":"0a822c60673d3d45fed5","453":"2a0637b8dc8c28d640ec"}[chunkId] + ".js";
};